import type { ReactNode } from 'react'

export const CourseSideMenuSkeleton = (): ReactNode => (
  <div className={`h-[calc(80vh)] w-full animate-pulse rounded-md bg-THEME-disabled lg:w-82.5`} />
)
